/// <reference path="../include.ts" />

namespace project_common {

	export class CurrentState {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			this.currentRegion = null;
			this.currentArea = null;
			this.currentZone = null;
			this.currentSpecies = null;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		public currentRegion:Region;
		public currentArea:Area;
		public currentZone:Zone;
		public currentSpecies:Species;
	}
}
